namespace Portico.Directives {

	import pm = Portico.Models;
    import pme = Portico.Models.Enterprise;
	import ps = Portico.Services;
    import Inject = Portico.Decorators.Inject;

    export interface ITcConsentController {
        change: () => void;
        controlClass: string;
        disabled: string;
        groupClass: string;
        inputClass: string;
		key: pme.Account;
        labelClass: string;
		questionId: string;
        readonly: string;
        required: string;
        requiredMessage: string;
        type: string;
		valueDefault: number | string;
		valueNone: number | string;

		intakeLayout: pme.IntakeLayout;
		survey: pme.Survey;
		surveyQuestion: pme.SurveyQuestion;
		value: any;

		onChange(): void;
        getSurveyAnswer(questionId: number): number | string;
    }

    export class TcConsentController implements ITcConsentController {
        change: () => void;
		controlClass: string;
        disabled: string;
        groupClass: string;
        inputClass: string;
		key: pme.Account;
        labelClass: string;
		questionId: string;
        readonly: string;
        required: string;
        requiredMessage: string;
        type: string;
		valueDefault: number | string;
		valueNone: number | string;

		intakeLayout: pme.IntakeLayout;
		survey: pme.Survey;
		surveyQuestion: pme.SurveyQuestion;
		value: any;

		constructor(private dataService: ps.IDataService, private porticoService: ps.IPorticoService) {
        }

        onChange() {
			const surveyId = this.dataService.getEnvironmentId(this.survey.surveyId);
			const surveySession = this.key.getSurveySession(surveyId);
			const questionId = this.dataService.getEnvironmentId(this.surveyQuestion.questionId);
			let answer: string = null;
			let answerIds: number[] = [];

			if (this.surveyQuestion.questionTypeId === pm.QuestionType.Date || this.surveyQuestion.questionTypeId === pm.QuestionType.FreeForm) {
				answer = this.value;
				answerIds.push(this.surveyQuestion.surveyAnswers[0].answerId);
			} else if (this.surveyQuestion.questionTypeId === pm.QuestionType.MultipleChoiceMultiAnswer) {
				if (this.value.length > 1) {
					this.value = this.value.filter((v) => {
						return v != this.valueNone;
					});
				}

				answerIds = this.value;
			} else {
				answerIds.push(parseInt(this.value));
            }

			surveySession.setSurveySessionAnswers(questionId, answerIds, answer);

			if (this.change) {
				this.change();
			}
        }

        // can this be moved to a service?
        getSurveyAnswer(questionId: number): any {
			const surveyId = this.dataService.getEnvironmentId(this.survey.surveyId);
			const surveySession = this.key.getSurveySession(surveyId);
			const values: any[] = [];

			this.surveyQuestion.surveyAnswers.forEach((sa) => {
				const surveySessionAnswers = surveySession.surveySessionAnswers.filter((ssa) => {
					return ssa.questionId === this.surveyQuestion.questionId && ssa.answerId === sa.answerId;
				});

				if (surveySessionAnswers.length > 0) {
					if (this.surveyQuestion.questionTypeId === pm.QuestionType.Date) {
						values.push(new Date(surveySessionAnswers[0].answerValue));
					} else if (this.surveyQuestion.questionTypeId === pm.QuestionType.FreeForm) {
						values.push(surveySessionAnswers[0].answerValue);
					} else {
						values.push(surveySessionAnswers[0].answerId);
					}
				}
			});

			if (this.surveyQuestion.questionTypeId === pm.QuestionType.MultipleChoiceMultiAnswer) {
				return values;
			}

			return values.length > 0 ? values[0] : null;
        }
    }

    angular.module('app').directive('tcConsent', [
        '$compile',
		'$state',
		'dataService', (
            $compile: angular.ICompileService,
			$state: angular.ui.IStateService,
			dataService: ps.IDataService
		) => {
            return {
                bindToController: {
                    change: '&?',
                    controlClass: '@',
                    disabled: '@',
                    groupClass: '@',
                    inputClass: '@',
                    key: '=',
                    labelClass: '@',
                    questionId: '@',
                    readonly: '@',
                    required: '@',
                    requiredMessage: '@',
					type: '@',
					valueDefault: '@',
					valueNone: '@'
                },
				controller: ['dataService', 'porticoService', <any>TcConsentController],
                controllerAs: '$question',
                link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
                    const tcConsent: ITcConsentController = $ctrl[0];
					const intakeLayout = dataService.enterprise.intakeLayout;
					const questionId = dataService.getEnvironmentId(tcConsent.questionId);
					let inputAttrs = `change="$question.onChange()" `;

                    tcConsent.intakeLayout = intakeLayout;
					tcConsent.survey = intakeLayout.getSurveyByQuestionId(questionId);
					tcConsent.surveyQuestion = intakeLayout.getSurveyQuestion(questionId);
					tcConsent.value = tcConsent.getSurveyAnswer(questionId);

					if (tcConsent.surveyQuestion.questionTypeId == pm.QuestionType.MultipleChoiceMultiAnswer) {
						if (tcConsent.valueDefault != null) {
							tcConsent.valueDefault = dataService.getEnvironmentId(tcConsent.valueDefault);
						}

						if (tcConsent.valueNone != null) {
							tcConsent.valueNone = dataService.getEnvironmentId(tcConsent.valueNone);
						}
					} else {
                        throw 'MUST USE MULTI_CHOICE_MULTI_ANSWER';
                    }

					if ((angular.isArray(tcConsent.value) && tcConsent.value.length == 0) || (tcConsent.value == null)) {
						let value = null;

						if (tcConsent.valueDefault) {
							value = tcConsent.valueDefault;
						} else if (tcConsent.valueNone) {
							value = tcConsent.valueNone;
						}

						if (value) {
							if (tcConsent.surveyQuestion.questionTypeId === pm.QuestionType.MultipleChoiceMultiAnswer) {
								tcConsent.value.push(value);
							} else {
								tcConsent.value = value;
							}

							tcConsent.onChange();
						}
					}

					if (tcConsent.controlClass) {
						inputAttrs += `control-class="${tcConsent.controlClass}" `;
                    }

					if (tcConsent.disabled) {
						inputAttrs += `disabled="${tcConsent.disabled}" `;
                    }

					if (tcConsent.groupClass) {
						inputAttrs += `group-class="${tcConsent.groupClass}" `;
					}

					if (tcConsent.inputClass) {
						inputAttrs += `input-class="${tcConsent.inputClass}" `;
                    }

					if (tcConsent.labelClass) {
						inputAttrs += `label-class="${tcConsent.labelClass}" `;
                    }

					if (tcConsent.readonly) {
						inputAttrs += `readonly="${tcConsent.readonly}" `;
                    }

					if (tcConsent.required) {
						inputAttrs += `required="${tcConsent.required}" `;
                    }

					if (tcConsent.requiredMessage) {
						inputAttrs += `required-message="${tcConsent.requiredMessage}" `;
                    }

					if (tcConsent.valueDefault) {
						inputAttrs += `value-default="${tcConsent.valueDefault}" `;
					}

					if (tcConsent.valueNone) {
						inputAttrs += `value-none="${tcConsent.valueNone}" `;
					}
					
					inputAttrs += `list="$question.surveyQuestion.surveyAnswers" `;
					inputAttrs += `list-label="answerValue" `;
					inputAttrs += `list-value="answerId" `;

                    const html = `<tc-input type="consent" key="$question.value" index="${questionId}" label="{{$question.surveyQuestion.questionText}}" ${inputAttrs} />`;

                    $element.html(html);
                    $compile($element.contents() as any)($scope);
                },
                restrict: 'E',
				require: ['tcConsent'],
				scope: true
            }
		}
	]);
}